/* lua.js generated code 0.3.0 */

IntroManager = xClass("IntroManager")
// var GameGuideTimelineAnims = require("clover/gameGuide/GameGuideTimelineAnims")
IntroType = table(
    [1, "kProp", 1],
    [1, "kGameMode", 2],
    [1, "kGameEle", 3],
    [1, "kGameSpecial", 4]
)
IntroConfig = table(
    [0, table(
        [1, "id", 20001],
        [1, "res", "help_panel/mode_order.png"],
        [1, "title", getText("help.gamemode1.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.gamemode1.text1")])], [0, table([1, "desc", getText("help.gamemode1.text2")])])]
    )],
    [0, table(
        [1, "id", 20002],
        [1, "res", "help_panel/mode_fish.png"],
        [1, "resOffset", cc.p(-3, 5)],
        [1, "title", getText("help.gamemode2.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.gamemode2.text1")], [1, "animName", "colorless_fish"])], [0, table([1, "desc", getText("help.gamemode2.text3")])])]
    )],
    [0, table(
        [1, "id", 20003],
        [1, "res", "help_panel/mode_ice.png"],
        [1, "title", getText("help.gamemode3.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.gamemode3.text1")], [1, "animName", "ice"])], [0, table([1, "desc", getText("help.gamemode3.text2")])])]
    )],
    [0, table(
        [1, "id", 20004],
        [1, "res", "help_panel/mode_collect.png"],
        [1, "title", getText("help.gamemode4.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.gamemode4.text1")], [1, "animName", "toy_collect"])], [0, table([1, "desc", getText("help.gamemode4.text2")], [1, "animName", "toy"])])]
    )],
    [0, table(
        [1, "id", 20005],
        [1, "res", "help_panel/mode_boss.png"],
        [1, "title", getText("help.gamemode5.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.gamemode5.text1")], [1, "animName", "boss"])], [0, table([1, "desc", getText("help.gamemode5.text2")])])]
    )],
    [0, table(
        [1, "id", 20006],
        [1, "res", "help_panel/mode_waterdig.png"],
        [1, "title", getText("help.gamemode6.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.gamemode6.text1")], [1, "animName", "water_dig"])], [0, table([1, "desc", getText("help.gamemode6.text2")], [1, "animName", "reef"])])]
    )],
    [0, table(
        [1, "id", 20007],
        [1, "res", "help_panel/mode_pursue.png"],
        [1, "title", getText("help.gamemode11.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.gamemode11.text1")], [1, "animName", "pursue"])])]
    )],
    [0, table(
        [1, "id", 30001],
        [1, "res", "help_panel/ele_softcandy.png"],
        [1, "title", getText("help.block1.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block1.text")], [1, "animName", "candy"])])]
    )],
    [0, table(
        [1, "id", 30002],
        [1, "res", "help_panel/ele_ice.png"],
        [1, "title", getText("help.block2.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block2.text")], [1, "animName", "snowblock"])])]
    )],
    [0, table(
        [1, "id", 30003],
        [1, "res", "help_panel/ele_bubble.png"],
        [1, "title", getText("help.block3.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block3.text")])])]
    )],
    [0, table(
        [1, "id", 30004],
        [1, "res", "help_panel/ele_honey.png"],
        [1, "title", getText("help.block4.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block4.text")], [1, "animName", "honey"])])]
    )],
    [0, table(
        [1, "id", 30005],
        [1, "res", "help_panel/ele_rose.png"],
        [1, "title", getText("help.block5.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block5.text")], [1, "animName", "rose"])])]
    )],
    [0, table(
        [1, "id", 30006],
        [1, "res", "help_panel/ele_cirrus.png"],
        [1, "title", getText("help.block6.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block6.text")], [1, "animName", "cage"])])]
    )],
    [0, table(
        [1, "id", 30007],
        [1, "res", "help_panel/ele_generator.png"],
        [1, "title", getText("help.block7.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block7.text")], [1, "animName", "generator"])])]
    )],
    [0, table(
        [1, "id", 30008],
        [1, "res", "help_panel/ele_butterfly.png"],
        [1, "title", getText("help.block8.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block8.text")], [1, "animName", "butterfly"])])]
    )],
    [0, table(
        [1, "id", 30009],
        [1, "res", "help_panel/ele_blockcirrus.png"],
        [1, "title", getText("help.block9.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block9.text")], [1, "animName", "ice_chain"])])]
    )],
    [0, table(
        [1, "id", 30010],
        [1, "res", "help_panel/ele_blockrope.png"],
        [1, "title", getText("help.block10.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block10.text")])])]
    )],
    [0, table(
        [1, "id", 30011],
        [1, "res", "help_panel/ele_fruit.png"],
        [1, "title", getText("help.block11.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block11.text")], [1, "animName", "orange"])])]
    )],
    [0, table(
        [1, "id", 30012],
        [1, "res", "help_panel/ele_coco.png"],
        [1, "title", getText("help.block12.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block12.text")])])]
    )],
    [0, table(
        [1, "id", 30013],
        [1, "res", "help_panel/ele_starfish.png"],
        [1, "title", getText("help.block13.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block13.text")])])]
    )],
    [0, table(
        [1, "id", 30014],
        [1, "res", "help_panel/ele_blackwtf.png"],
        [1, "title", getText("help.block14.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block14.text")])])]
    )],
    [0, table(
        [1, "id", 30015],
        [1, "res", "help_panel/ele_movetile.png"],
        [1, "title", getText("help.block15.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block15.text")])])]
    )],
    [0, table(
        [1, "id", 30016],
        [1, "res", "help_panel/ele_venom.png"],
        [1, "title", getText("help.block16.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block16.text")], [1, "animName", "venom"])])]
    )],
    [0, table(
        [1, "id", 30017],
        [1, "res", "help_panel/ele_flower.png"],
        [1, "title", getText("help.block17.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block17.text")])])]
    )],
    [0, table(
        [1, "id", 30018],
        [1, "res", "help_panel/ele_jellyfish.png"],
        [1, "title", getText("help.block18.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block18.text")])])]
    )],
    [0, table(
        [1, "id", 30019],
        [1, "res", "help_panel/ele_beehive.png"],
        [1, "title", getText("help.block19.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block19.text")], [1, "animName", "beehive"])])]
    )],
    [0, table(
        [1, "id", 30020],
        [1, "res", "help_panel/ele_lotus.png"],
        [1, "title", getText("help.block20.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block20.text")], [1, "animName", "lotus"])])]
    )],
    [0, table(
        [1, "id", 30021],
        [1, "res", "help_panel/ele_pagurian.png"],
        [1, "title", getText("help.block21.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block21.text")])])]
    )],
    [0, table(
        [1, "id", 30022],
        [1, "res", "help_panel/ele_hat.png"],
        [1, "title", getText("help.block22.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block22.text")])])]
    )],
    [0, table(
        [1, "id", 30023],
        [1, "res", "help_panel/ele_colorcollect.png"],
        [1, "title", getText("help.block23.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block23.text")])])]
    )],
    [0, table(
        [1, "id", 30024],
        [1, "res", "help_panel/ele_chocolate.png"],
        [1, "title", getText("help.block24.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block24.text")])])]
    )],
    [0, table(
        [1, "id", 30025],
        [1, "res", "help_panel/ele_cake.png"],
        [1, "title", getText("help.block25.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block25.text")])])]
    )],
    [0, table(
        [1, "id", 30026],
        [1, "res", "help_panel/ele_waterbomb.png"],
        [1, "title", getText("help.block26.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block26.text")], [1, "animName", "waterbomb"])])]
    )],
    [0, table(
        [1, "id", 30027],
        [1, "res", "help_panel/ele_bowknot.png"],
        [1, "title", getText("help.block27.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block27.text")], [1, "animName", "bowknot"])])]
    )],
    [0, table(
        [1, "id", 30028],
        [1, "res", "help_panel/ele_produce_mark.png"],
        [1, "title", getText("help.block28.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block28.text")], [1, "animName", "produceMark"])])]
    )],
    [0, table(
        [1, "id", 30029],
        [1, "res", "help_panel/ele_shell.png"],
        [1, "title", getText("help.block29.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block29.text")], [1, "animName", "shell"])])]
    )],
    [0, table(
        [1, "id", 30030],
        [1, "res", "help_panel/ele_soda.png"],
        [1, "title", getText("help.block30.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block30.text")], [1, "animName", "soda"])])]
    )],
    [0, table(
        [1, "id", 30031],
        [1, "res", "help_panel/ele_super_honey_bottle.png"],
        [1, "title", getText("help.block31.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block31.text")], [1, "animName", "superHoneyBottle"])])]
    )],
    [0, table(
        [1, "id", 30032],
        [1, "res", "help_panel/ele_candy_floss.png"],
        [1, "title", getText("help.block32.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block32.text")], [1, "animName", "candyFloss"])])]
    )],
    [0, table(
        [1, "id", 30033],
        [1, "res", "help_panel/ele_ratel.png"],
        [1, "title", getText("help.block33.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block33.text")], [1, "animName", "ratel"])])]
    )],
    [0, table(
        [1, "id", 30034],
        [1, "res", "help_panel/ele_vulnerable.png"],
        [1, "title", getText("help.block34.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block34.text")], [1, "animName", "vulnerable"])])]
    )],
    [0, table(
        [1, "id", 30035],
        [1, "res", "help_panel/ele_capsuleToy.png"],
        [1, "title", getText("help.block35.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block35.text")], [1, "animName", "capsuleToy"])])]
    )],
    [0, table(
        [1, "id", 30036],
        [1, "res", "help_panel/ele_grass.png"],
        [1, "title", getText("help.block36.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block36.text")], [1, "animName", "grass"])])]
    )],
    [0, table(
        [1, "id", 30037],
        [1, "res", "help_panel/ele_ice_bomb.png"],
        [1, "title", getText("help.block37.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block37.text")], [1, "animName", "iceBomb"])])]
    )],
    [0, table(
        [1, "id", 30038],
        [1, "res", "help_panel/ele_cake_shooter.png"],
        [1, "title", getText("help.block38.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block38.text")], [1, "animName", "cakeShooter"])])]
    )],
    [0, table(
        [1, "id", 30039],
        [1, "res", "help_panel/ele_gummy_worm.png"],
        [1, "title", getText("help.block39.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block39.text")], [1, "animName", "gummyWorm"])])]
    )],
    [0, table(
        [1, "id", 30040],
        [1, "res", "help_panel/ele_nest_doll.png"],
        [1, "title", getText("help.block40.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block40.text")], [1, "animName", "nestDoll"])])]
    )],
    [0, table(
        [1, "id", 30041],
        [1, "res", "help_panel/ele_rocket.png"],
        [1, "title", getText("help.block41.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block41.text")], [1, "animName", "rocket"])])]
    )],
    [0, table(
        [1, "id", 30042],
        [1, "res", "help_panel/ele_colored_frosting.png"],
        [1, "title", getText("help.block42.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block42.text")], [1, "animName", "coloredFrosting"])])]
    )],
    [0, table(
        [1, "id", 30043],
        [1, "res", "help_panel/ele_candy_yoyo.png"],
        [1, "title", getText("help.block43.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block43.text")], [1, "animName", "candyYoyo"])])]
    )],
    [0, table(
        [1, "id", 30044],
        [1, "res", "help_panel/ele_jam_jar.png"],
        [1, "title", getText("help.block44.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block44.text")], [1, "animName", "jamJar"])])]
    )],
    [0, table(
        [1, "id", 30045],
        [1, "res", "help_panel/ele_mint.png"],
        [1, "title", getText("help.block45.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block45.text")], [1, "animName", "mint"])])]
    )],
    [0, table(
        [1, "id", 30046],
        [1, "res", "help_panel/ele_sea_anemone.png"],
        [1, "title", getText("help.block46.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block46.text")], [1, "animName", "seaAnemone"])])]
    )],
    [0, table(
        [1, "id", 30047],
        [1, "res", "help_panel/ele_mushroom.png"],
        [1, "title", getText("help.block47.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block47.text")], [1, "animName", "mushroom"])])]
    )],
    [0, table(
        [1, "id", 30048],
        [1, "res", "help_panel/ele_fishnet.png"],
        [1, "title", getText("help.block48.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block48.text")], [1, "animName", "fishnet"])])]
    )],
    [0, table(
        [1, "id", 30049],
        [1, "res", "help_panel/ele_ufo.png"],
        [1, "title", getText("help.block49.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block49.text")], [1, "animName", "ufo"])])]
    )],
    [0, table(
        [1, "id", 30050],
        [1, "res", "help_panel/ele_flash_bird.png"],
        [1, "title", getText("help.block50.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block50.text")], [1, "animName", "flash_bird"])])]
    )],
    [0, table(
        [1, "id", 30051],
        [1, "res", "help_panel/ele_cheese_rat.png"],
        [1, "title", getText("help.block51.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block51.text")], [1, "animName", "cheese_rat"])])]
    )],
    [0, table(
        [1, "id", 30052],
        [1, "res", "help_panel/ele_pastry.png"],
        [1, "title", getText("help.block52.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block52.text")], [1, "animName", "pastry"])])]
    )],
    [0, table(
        [1, "id", 30053],
        [1, "res", "help_panel/ele_croissant.png"],
        [1, "title", getText("help.block53.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block53.text")], [1, "animName", "croissant"])])]
    )],
    [0, table(
        [1, "id", 30054],
        [1, "res", "help_panel/ele_popcan.png"],
        [1, "title", getText("help.block54.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block54.text")], [1, "animName", "popcan"])])]
    )],
    [0, table(
        [1, "id", 30055],
        [1, "res", "help_panel/ele_filbert.png"],
        [1, "title", getText("help.block55.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block55.text")], [1, "animName", "filbert"])])]
    )],
    [0, table(
        [1, "id", 30056],
        [1, "res", "help_panel/ele_firework.png"],
        [1, "title", getText("help.block56.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block56.text")], [1, "animName", "firecracker"])])]
    )],
    [0, table(
        [1, "id", 30057],
        [1, "res", "help_panel/ele_firecracker.png"],
        [1, "title", getText("help.block57.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block57.text")], [1, "animName", "firecracker"])])]
    )],
    [0, table(
        [1, "id", 30058],
        [1, "res", "help_panel/ele_icecream.png"],
        [1, "title", getText("help.block58.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block58.text")], [1, "animName", "icecream"])])]
    )],
    [0, table(
        [1, "id", 30059],
        [1, "res", "help_panel/ele_lamp.png"],
        [1, "title", getText("help.block59.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block59.text")], [1, "animName", "lamp"])])]
    )],
    [0, table(
        [1, "id", 30060],
        [1, "res", "help_panel/ele_laser.png"],
        [1, "title", getText("help.block60.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block60.text")], [1, "animName", "laser"])])]
    )],
    [0, table(
        [1, "id", 30061],
        [1, "res", "help_panel/ele_egg.png"],
        [1, "title", getText("help.block61.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block61.text")], [1, "animName", "egg"])])]
    )],
    [0, table(
        [1, "id", 30062],
        [1, "res", "help_panel/ele_dye.png"],
        [1, "title", getText("help.block62.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block62.text")], [1, "animName", "dye"])])]
    )],
    [0, table(
        [1, "id", 30063],
        [1, "res", "help_panel/ele_magicbottle.png"],
        [1, "title", getText("help.block63.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block63.text")], [1, "animName", "magicbottle"])])]
    )],
    [0, table(
        [1, "id", 30064],
        [1, "res", "help_panel/ele_dinnertable.png"],
        [1, "title", getText("help.block64.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block64.text")], [1, "animName", "dinnertable"])])]
    )],
    [0, table(
        [1, "id", 30065],
        [1, "res", "help_panel/ele_bombCandy.png"],
        [1, "title", getText("help.block65.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block65.text")], [1, "animName", "bombCandy"])])]
    )],
    [0, table(
        [1, "id", 30066],
        [1, "res", "help_panel/ele_torpedo.png"],
        [1, "title", getText("help.block66.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block66.text")], [1, "animName", "torpedo"])])]
    )],
    [0, table(
        [1, "id", 30067],
        [1, "res", "help_panel/ele_biscuit.png"],
        [1, "title", getText("help.block67.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block67.text")], [1, "animName", "biscuit"])])]
    )],
    [0, table(
        [1, "id", 30068],
        [1, "res", "help_panel/ele_popcorn.png"],
        [1, "title", getText("help.block68.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block68.text")], [1, "animName", "popcorn"])])]
    )],
    [0, table(
        [1, "id", 30069],
        [1, "res", "help_panel/ele_nest.png"],
        [1, "title", getText("help.block69.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block69.text")], [1, "animName", "nest"])])]
    )],
    [0, table(
        [1, "id", 30070],
        [1, "res", "help_panel/ele_hunter.png"],
        [1, "title", getText("help.block70.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block70.text")], [1, "animName", "hunter"])])]
    )],
    [0, table(
        [1, "id", 30071],
        [1, "res", "help_panel/ele_diamond.png"],
        [1, "title", getText("help.block71.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block71.text")], [1, "animName", "diamond"])])]
    )],
    [0, table(
        [1, "id", 30072],
        [1, "res", "help_panel/ele_turnTileControl.png"],
        [1, "title", getText("help.block72.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block72.text")], [1, "animName", "turnTile"])])]
    )],
    [0, table(
        [1, "id", 30073],
        [1, "res", "help_panel/ele_cannedFish.png"],
        [1, "title", getText("help.block73.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block73.text")], [1, "animName", "cannedFish"])])]
    )],
    [0, table(
        [1, "id", 30074],
        [1, "res", "help_panel/ele_shark.png"],
        [1, "title", getText("help.block74.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block74.text")], [1, "animName", "shark"])])]
    )],
    [0, table(
        [1, "id", 30075],
        [1, "res", "help_panel/ele_minioctopus.png"],
        [1, "title", getText("help.block75.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block75.text")], [1, "animName", "minioctopus"])])]
    )],
    [0, table(
        [1, "id", 30076],
        [1, "res", "help_panel/ele_jamBox.png"],
        [1, "title", getText("help.block76.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block76.text")])])]
    )],
    [0, table(
        [1, "id", 30077],
        [1, "res", "help_panel/ele_foambomb.png"],
        [1, "title", getText("help.block77.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block77.text")])])]
    )],
    [0, table(
        [1, "id", 30078],
        [1, "res", "help_panel/ele_icepopbox.png"],
        [1, "title", getText("help.block78.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block78.text")])])]
    )],
    [0, table(
        [1, "id", 30079],
        [1, "res", "help_panel/ele_safe.png"],
        [1, "title", getText("help.block79.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block79.text")])])]
    )],
    [0, table(
        [1, "id", 30080],
        [1, "res", "help_panel/ele_circus.png"],
        [1, "title", getText("help.block80.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block80.text")])])]
    )],
    [0, table(
        [1, "id", 30081],
        [1, "res", "help_panel/ele_woodBox.png"],
        [1, "title", getText("help.block81.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.block81.text")])])]
    )],
    [0, table(
        [1, "id", 40001],
        [1, "res", "help_panel/special_fourline.png"],
        [1, "title", getText("help.special1.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.special1.text")], [1, "animName", "line"])])]
    )],
    [0, table(
        [1, "id", 40002],
        [1, "res", "help_panel/special_fourtile.png"],
        [1, "title", getText("help.special2.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.special2.text")], [1, "animName", "four_tile"])])]
    )],
    [0, table(
        [1, "id", 40003],
        [1, "res", "help_panel/special_bloom.png"],
        [1, "title", getText("help.special3.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.special3.text")], [1, "animName", "wrap"])])]
    )],
    [0, table(
        [1, "id", 40004],
        [1, "res", "help_panel/special_superbird.png"],
        [1, "title", getText("help.special4.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.special4.text")], [1, "animName", "bird"])])]
    )],
    [0, table(
        [1, "id", 40005],
        [1, "res", "help_panel/special_superbirdcolor.png"],
        [1, "title", getText("help.special5.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.special5.text")], [1, "animName", "super_bird"])])]
    )],
    [0, table(
        [1, "id", 40006],
        [1, "res", "help_panel/special_superchange.png"],
        [1, "title", getText("help.special6.title")],
        [1, "intros", table([0, table([1, "desc", getText("help.special6.text")])])]
    )]
)
var instance = null
IntroManager.getInstance = function () {
    if (!instance) {
        instance = IntroManager.new()
        instance.init()
    }
    return instance
}
IntroManager.prototype.init = function () {
    var self = this
    self.config = table()
    self.typeConfig = table()
    for (var k = 1, v = IntroConfig[1]; v; k++, v = IntroConfig[k]) {
        self.config[v.id] = v
        var _type = Math.floor(v.id / 10000)
        if (!self.typeConfig[_type]) {
            self.typeConfig[_type] = table()
        }
        table.insert(self.typeConfig[_type], v.id)
    }
}
IntroManager.prototype.getUnlockedIntroCount = function (topLevelId) {
    var count = 0
    var introMeta = MetaManager.getInstance().getIntroMeta()
    for (var k = 1, v = introMeta[1]; v; k++, v = introMeta[k]) {
        if (topLevelId >= v.unlockLevel) {
            count = count + 1
        }
    }
    return count
}
IntroManager.prototype.getUnlockedIntrosByCategory = function (category) {
    var topLevelId = UserManager.getInstance().getUserRef().getTopLevelId()
    var introMetas = MetaManager.getInstance().getIntrosByCategory(category)
    var unlockIntros = table()
    for (var k = 1, v = introMetas[1]; v; k++, v = introMetas[k]) {
        if (topLevelId >= v.unlockLevel) {
            table.insert(unlockIntros, v)
        }
    }
    table.sort(unlockIntros, function (a, b) {
        return a.sort < b.sort
    })
    return unlockIntros
}
IntroManager.prototype.hasItemNotChecked = function () {
    var self = this
    var checkLevel = UserManager.getInstance().getIntroCheckedLevelId()
    var unlockCount = self.getUnlockedIntroCount(checkLevel)
    var topLevelId = UserManager.getInstance().getUserRef().getTopLevelId()
    var newUnlockCount = self.getUnlockedIntroCount(topLevelId)
    return newUnlockCount > unlockCount
}
IntroManager.prototype.getConfig = function (id) {
    var self = this
    // body
    return self.config[id]
}
IntroManager.prototype.getConfigsByType = function (kindType) {
    var self = this
    // body
    var list = table()
    if (self.typeConfig[kindType]) {
        for (var k = 1, v = self.typeConfig[kindType][1]; v; k++, v = self.typeConfig[kindType][k]) {
            list[v] = self.getConfig(v)
        }
    }
    return list
}
IntroManager.prototype.getAnim = function (itemId, animName) {
    // var [anim, action] = GameGuideTimelineAnims.obstacle(table([1, "obstName", animName]))
    // var size = anim.getContentSize()
    // var clip = cc.ClippingRectangleNode.create()
    // clip.setClippingRegion(cc.rect(0, -size.height, size.width, size.height))
    // clip.setContentSize(cc.size(size.width, size.height))
    // clip.setClippingEnabled(true)
    // clip.addChild(anim)
    // action.gotoFrameAndPlay(0)
    // return clip
    return cc.Node.create()
}
IntroManager.prototype.getPic = function (itemId, animName) {
    var sprite = cc.Sprite.create(animName)
    sprite.setAnchorPoint(0, 1)
    return sprite
}
